import React, { memo } from 'react'
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText
} from '@mui/material'

const CustomCheckbox = ({
  label,
  checked = false,
  onChange,
  error,
  ...restProps
}) => {
  return (
    <FormControl required error={!!error} variant='standard'>
      <FormControlLabel
        label={label}
        onClick={() => onChange && onChange()}
        control={
          <Checkbox
            size='medium'
            color='default'
            checked={checked}
            onChange={() => {}}
            sx={(theme) => ({
              color: error && theme.palette.error.main
            })}
            {...restProps}
          />
        }
      />

      {error && error.length ? <FormHelperText>{error}</FormHelperText> : ''}
    </FormControl>
  )
}

export default memo(CustomCheckbox)
